/**
 * テンプレート CSV のヘッダー行（13言語分 + 技術名形式）。
 *
 * `downloadTemplateCsv` は i18n の `glossary.columnLanguage` / `glossary.columnPhrase` /
 * `glossary.columnSoundsLike` を列見出しとして出力するため、パーサ側も同じ 13 言語の
 * ヘッダーを受け付ける必要がある。
 *
 * 各要素は `[1列目, 2列目, 3列目]` を **小文字化・トリム済み** で保持する。
 * パーサは firstCols に対して `c.trim().toLowerCase()` を適用したうえで照合する。
 *
 * ⚠️ `src/config/i18n/*.json` の `glossary.columnLanguage` / `columnPhrase` / `columnSoundsLike`
 *    を変更した場合はこのファイルも必ず更新すること。
 *    ずれは `glossaryHeaders.test.ts` で自動検出される。
 */
export const TEMPLATE_HEADER_ROWS: readonly (readonly [
  string,
  string,
  string,
])[] = [
  ['言語', '語句', '読み方'], // ja-jp
  ['language', 'phrase', 'pronunciation'], // en-us
  ['sprache', 'ausdruck', 'aussprache'], // de-de
  ['idioma', 'frase', 'pronunciación'], // es-es
  ['langue', 'expression', 'prononciation'], // fr-fr
  ['lingua', 'frase', 'pronuncia'], // it-it
  ['언어', '어구', '발음'], // ko-kr
  ['bahasa', 'frasa', 'sebutan'], // ms-my
  ['idioma', 'frase', 'pronúncia'], // pt-pt
  ['язык', 'фраза', 'произношение'], // ru-ru
  ['ภาษา', 'วลี', 'การออกเสียง'], // th-th
  ['语言', '短语', '读音'], // zh-cn
  ['語言', '短語', '讀音'], // zh-tw
  ['language', 'content', 'sounds_like'], // Speechmatics の API フィールド名形式（content / sounds_like）仕様書・テストで使用
] as const;
